import { Link, Route, Routes, useLocation } from 'react-router-dom';
import WatchlistPage from './pages/Watchlist';
import WikiPage from './pages/Wiki';
import FeedPage from './pages/Feed';
import AskPage from './pages/Ask';
import AskHistoryPage from './pages/AskHistory';
import SettingsPage from './pages/Settings';
import ReportsPage from './pages/Reports';
import ReportMdPage from './pages/ReportMd';
import AdminReportsPage from './pages/AdminReports';
import AdminSettingsPage from './pages/AdminSettings';
import AdminVisionStatsPage from './pages/AdminVisionStats';
import AdminWikiOpsPage from './pages/AdminWikiOps';

const navItems = [
  { to: '/', label: '워치리스트' },
  { to: '/reports', label: 'Reports' },
  { to: '/admin/reports', label: '+ 가용 보고서' },
  { to: '/admin/vision-stats', label: '📊 LLM Stats' },
  { to: '/admin/wiki-ops', label: '🛠 위키 운영' },
  { to: '/admin/settings', label: '⚙️ Admin' },
  { to: '/feed', label: '피드' },
  { to: '/ask', label: 'Ask' },
  { to: '/ask-history', label: 'Ask 기록' },
  { to: '/settings', label: '설정' },
];

function Header() {
  const loc = useLocation();
  return (
    <header className="sticky top-0 z-10 border-b border-slate-200 bg-white/90 backdrop-blur">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3">
        <Link to="/" className="text-lg font-semibold tracking-tight">
          research<span className="text-indigo-600">HQ</span>
        </Link>
        <nav className="flex items-center gap-1 text-sm">
          {navItems.map((n) => {
            // `to + '/'` 경계 매치 — `/ask` 가 `/ask-history` 를 잡지 않게(prefix 오매칭 방지).
            const active = loc.pathname === n.to || (n.to !== '/' && loc.pathname.startsWith(n.to + '/'));
            return (
              <Link
                key={n.to}
                to={n.to}
                className={`rounded-md px-3 py-1.5 ${
                  active ? 'bg-slate-900 text-white' : 'text-slate-600 hover:bg-slate-100'
                }`}
              >
                {n.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </header>
  );
}

export default function App() {
  return (
    <div className="min-h-screen font-sans">
      <Header />
      <main className="mx-auto max-w-6xl px-6 py-6">
        <Routes>
          <Route path="/" element={<WatchlistPage />} />
          <Route path="/wikis/:symbol" element={<WikiPage />} />
          <Route path="/feed" element={<FeedPage />} />
          <Route path="/ask" element={<AskPage />} />
          <Route path="/ask-history" element={<AskHistoryPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/reports/:id/md" element={<ReportMdPage />} />
          <Route path="/admin/reports" element={<AdminReportsPage />} />
          <Route path="/admin/settings" element={<AdminSettingsPage />} />
          <Route path="/admin/vision-stats" element={<AdminVisionStatsPage />} />
          <Route path="/admin/wiki-ops" element={<AdminWikiOpsPage />} />
        </Routes>
      </main>
    </div>
  );
}
